<template>
  <div>
    <div class="main-content">
      <div class="row p-2">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 text-right mb-1">
                  <span
                    class="badge badge-warning mr-1"
                    v-show="
                      !pedido.data_inicio &&
                      !pedido.suplementar &&
                      !pedido.rapido
                    "
                    >Pedido SOS</span
                  >
                  <span
                    class="badge badge-secondary mr-1"
                    v-show="!pedido.data_inicio && pedido.suplementar"
                    >Pedido Suplementar</span
                  >
                  <span
                    class="badge badge-info mr-1"
                    v-show="!pedido.data_inicio && pedido.rapido"
                    >Pedido Rapido</span
                  >
                  <span class="badge" :class="'badge-' + pedido.status_class">
                    {{ pedido.status_f }}
                  </span>
                </div>
                <div class="col-md-6" v-show="pedido.data_inicio">
                  <label>Data inicial</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="pedido.data_inicio"
                    disabled
                  />
                </div>
                <div class="col-md-6" v-show="pedido.data_fim">
                  <label>Data final</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="pedido.data_fim"
                    disabled
                  />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitante</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pedido.u_solicitante.nome"
                    disabled
                  />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitada</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="pedido.u_solicitada.nome"
                    disabled
                  />
                </div>
                <div class="col-md-12">
                  <label>Observações</label>
                  <div class="row px-1">
                    <div
                      class="col-md-12 p-1"
                      style="border: 1px solid #ccc; border-radius: 8px"
                    >
                      <div v-html="pedido.observacoes"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-2" style="margin-top: -35px">
        <div
          class="col-md-12"
          id="lotes"
          v-for="(material_pedido, id) in pedido.materiais"
          :key="id"
        >
          <div
            class="card"
            style="border: 1px solid rgba(0, 0, 0, 0.125)"
            :style="
              'border-right: 8px solid ' +
              (material_pedido.atendido != null
                ? material_pedido.atendido
                  ? '#28c76f;'
                  : '#ea5455;'
                : '#15488a;')
            "
          >
            <div class="card-body">
              <div class="row">
                <div class="col-9 col-md-11">
                  <h5>
                    {{ material_pedido.material ? material_pedido.material.nome : 'Material não encontrado' }}
                  </h5>
                  <p>
                    Solicitado:
                    <b>{{ material_pedido.quantidade_solicitada }}</b>
                  </p>
                  <p>
                    Atendido: <b>{{ material_pedido.quantidade_atendida }}</b>
                  </p>
                </div>
                <div class="col-3 col-md-1 d-flex flex-column">
                  <button
                    class="btn btn-outline-danger p-1"
                    v-show="
                      pedido.status === 12 && material_pedido.atendido == null
                    "
                    @click="recusar(id)"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                  <button
                    class="btn btn-outline-success p-1 mt-1"
                    v-show="
                      pedido.status === 12 && material_pedido.atendido == null
                    "
                    @click="aceitar(id)"
                  >
                    <i class="fas fa-check"></i>
                  </button>
                  <button
                    class="btn btn-outline-primary p-1 mt-1"
                    v-show="
                      pedido.status === 12 &&
                      material_pedido.atendido != null &&
                      !pedido.recebido
                    "
                    @click="cancelar(id)"
                  >
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-2" v-if="pedido.status === 9">
        <div class="col-12">
          <label>Nome completo</label>
          <input type="text" class="form-control" v-model="separador.nome" />
        </div>
        <div class="col-12">
          <label>CPF</label>
          <input
            type="tel"
            class="form-control"
            v-model="separador.cpf"
            v-mask="'999.999.999-99'"
          />
        </div>
        <div class="col-12 mt-2">
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="separar()"
          >
            Iniciar separação
          </button>
        </div>
      </div>
      <div class="row p-2" v-if="pedido.status === 8">
        <div class="col-12">
          <button
            type="button"
            class="btn btn-primary w-100"
            @click="aguardarTransporte()"
          >
            Finalizar separação
          </button>
        </div>
      </div>
      <div
        class="row p-2"
        style="margin-top: -10px"
        v-show="[2, 3, 13].includes(pedido.status) && !pedido.recebido"
      >
        <div class="col-12">
          <label>Nome completo</label>
          <input type="text" class="form-control" v-model="entregador.nome" />
        </div>
        <div class="col-12">
          <label>CPF</label>
          <input
            type="tel"
            class="form-control"
            v-model="entregador.cpf"
            v-mask="'999.999.999-99'"
          />
        </div>
      </div>
      <div
        class="row p-2"
        style="margin-top: -10px"
        v-show="pedido.status === 12 && !pedido.recebido"
      >
        <div class="col-12">
          <label>Nome completo</label>
          <input type="text" class="form-control" v-model="recebedor.nome" />
        </div>
        <div class="col-12">
          <label>CPF</label>
          <input
            type="tel"
            class="form-control"
            v-model="recebedor.cpf"
            v-mask="'999.999.999-99'"
          />
        </div>
      </div>
      <div class="row p-2" v-if="[3, 13].includes(pedido.status)">
        <div class="col-12">
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            data-toggle="modal"
            data-target="#entregaModal"
          >
            Chegada no local
          </button>
        </div>
      </div>
      <div
        class="modal fade"
        id="entregaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="entregaModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h5 class="modal-title text-light" id="entregaModallLabel">
                Realizar entrega
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label>Observação</label>
              <textarea class="form-control" v-model="observacao"></textarea>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-danger w-100"
                data-toggle="modal"
                data-target="#entregaModal"
                @click="entregar(false)"
              >
                Não entregue
              </button>
              <button
                type="button"
                class="btn btn-outline-success w-100"
                data-toggle="modal"
                data-target="#entregaModal"
                @click="entregar(true)"
              >
                Entregue
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center p-2">
        <div class="col-12 mt-1 row" v-if="pedido.recebido">
          <div class="col-12 d-flex justify-content-center">
            <img :src="pedido.assinatura" alt="Assinatura" />
          </div>
          <div class="col-12 d-flex justify-content-center">
            {{ pedido.recebido == 1 ? "Recebido" : "Rejeitado" }} por
            {{ pedido.recebido_por }} às {{ pedido.recebido_em_f }}
          </div>
        </div>
        <div
          class="col-12 mt-1 row justify-content-center"
          v-show="!pedido.recebido && ![3, 8, 9, 13].includes(pedido.status)"
        >
          <div class="col-12 text-center">
            <h4>Desenhe sua assinatura abaixo</h4>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <!-- <canvas
              id="canvas"
              ref="canvas"
              style="border: 1px solid #000"
              width="300"
              height="150"
              @touchstart="startDrawing"
              @touchmove="draw"
              @touchend="stopDrawing"
              @mousedown="startDrawing"
              @mousemove="draw"
              @mouseup="stopDrawing"
              @mouseleave="stopDrawing"
            ></canvas> -->
            <VueSignaturePad
              width="300px"
              height="150px"
              style="border: 1px solid #000"
              ref="signaturePad"
            />
          </div>
          <div class="col-md-12 mt-1 row justify-content-center">
            <button class="btn btn-delete" @click="clearSignature">
              Limpar Assinatura
            </button>
          </div>
        </div>
      </div>
      <div class="row p-2" v-if="pedido.status === 12 && pedido.recebido == 0">
        <div class="col-md-12">
          <button
            :class="'btn btn-block btn-' + (recusado ? 'warning' : 'success')"
            :disabled="
              recebedor.nome && recebedor.cpf.length == 14 ? false : true
            "
            data-toggle="modal"
            data-target="#aprovar"
          >
            {{ recusado ? "Recebido parcialmente" : "Recebido" }}
          </button>
          <div
            class="modal fade"
            id="aprovar"
            tabindex="-1"
            role="dialog"
            aria-labelledby="aprovarLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="rejeitarLabel">
                    Receber pedido {{ recusado ? "parcialmente" : "" }}
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <textarea
                    class="form-control"
                    v-model="observacao"
                  ></textarea>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="receive(1)"
                  >
                    Aprovar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <button
            class="btn btn-danger btn-block"
            data-toggle="modal"
            data-target="#rejeitar"
            :disabled="
              recebedor.nome && recebedor.cpf.length == 14 ? false : true
            "
          >
            Não Recebido
          </button>
          <div
            class="modal fade"
            id="rejeitar"
            tabindex="-1"
            role="dialog"
            aria-labelledby="rejeitarLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="rejeitarLabel">
                    Motivo da rejeição
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <textarea
                    class="form-control"
                    v-model="observacao"
                  ></textarea>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    data-dismiss="modal"
                    @click="receive(2)"
                  >
                    Rejeitar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-2 justify-content-center centered" v-else>
        <div class="col-md-12" v-if="pedido.recebido == 1">
          <span class="badge badge-success">Recebido</span>
        </div>
        <div class="col-md-12" v-if="pedido.recebido == 2">
          <span class="badge badge-danger">Rejeitado</span>
        </div>
        <div class="col-md-12" v-if="pedido.recebido == 3">
          <span class="badge badge-warning">Recebido parcialmente</span>
        </div>
      </div>
      <div
        class="row p-2 justify-content-center centered"
        v-if="pedido.status === 2"
      >
        <div class="col-md-12">
          <button
            class="btn btn-primary btn-block"
            @click="retirar()"
            :disabled="
              entregador.nome && entregador.cpf.length == 14 ? false : true
            "
          >
            Retirar para entrega
          </button>
        </div>
      </div>
      <div class="row p-2" v-if="pedido.recebido">
        <div class="col-12 my-1">
          <MapComponent
            :latitude="pedido.latitude"
            :longitude="pedido.longitude"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import MapComponent from "../../components/MapComponent.vue";

export default {
  name: "imageUpload",
  data() {
    return {
      entregador: {
        nome: "",
        cpf: "",
      },
      recebedor: {
        nome: "",
        cpf: "",
      },
      separador: {
        nome: "",
        cpf: "",
      },
      entregador: {
        nome: "",
        cpf: "",
      },
      signature: [],
      pedido_material: [],
      pedido: {
        id: null,
        data_inicio: null,
        data_fim: null,
        suplementar: false,
        rapido: false,
        status: null,
        status_class: "",
        status_f: "",
        observacoes: "",
        recebido: null,
        assinatura: null,
        recebido_por: "",
        recebido_em_f: "",
        latitude: null,
        longitude: null,
        u_solicitante: {
          nome: ""
        },
        u_solicitada: {
          nome: ""
        },
        materiais: []
      },
      unidades: [],
      geolocalizacao: [],
      observacao: "",
      separado: true,
      recusado: false,
    };
  },
  computed: {},
  methods: {
    getPedidos: function (id) {
      const self = this;
      const api = self.$store.state.api + "public_pedidos";

      self.$loading(true);

      axios
        .post(api, { id: id })
        .then((response) => {
          self.pedido = response.data;

          if (self.pedido.status === 9) {
            $(document).ready(function () {
              $("#modalSeparacao").modal({ backdrop: "static" });
            });
          }

          if (self.pedido.status === 8) {
            $(document).ready(function () {
              $("#modalTransporte").modal({ backdrop: "static" });
            });
          }

          self.verificaRecusa();
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    retirar: function () {
      const self = this;
      const api = self.$store.state.api + "public_retirada";

      self.sendAssinatura();
      self.clearSignature();

      let retirado_por = self.entregador.nome + ` (${self.entregador.cpf})`;

      axios
        .post(api, { id: self.$route.params.id, retirado_por: retirado_por })
        .then((response) => {
          self.pedido = response.data;
          self.redirect();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    receive(obj) {
      const self = this;
      let liberar = 0;

      self.pedido.materiais.forEach((material) => {
        if (material.atendido == null) {
          liberar++;

          return self.$message(
            null,
            "Por favor, verifique se todos os materiais chegaram corretamente.",
            "error"
          );
        }
      });

      if (liberar === 0) {
        const api = self.$store.state.api + "public_pedido_data";

        self.pedido.recebido_por =
          self.recebedor.nome + ` (${self.recebedor.cpf})`;
        self.pedido.latitude = self.geolocalizacao.latitude;
        self.pedido.longitude = self.geolocalizacao.longitude;
        self.pedido.observacoes =
          self.pedido.observacoes +
          (self.observacao ? "<br><br><p>" + self.observacao + "</p>" : "");

        axios
          .post(api, { operation: obj, data: self.pedido })
          .then((response) => {
            self.sendAssinatura();
            self.getPedidos(self.pedido.id);
            self.redirect();
          })
          .catch((error) => {
            self.$message(null, error.response.data, "error");
          });
      }
    },
    formDataAssinatura: function () {
      const self = this;

      let fd = new FormData();
      fd.append("id", self.pedido.id);
      fd.append("signature", self.$refs.signaturePad.saveSignature().data);

      return fd;
    },
    sendAssinatura: function () {
      const self = this;
      let api = self.$store.state.api + "send_assinatura";

      let fd = self.formDataAssinatura();

      axios
        .post(api, fd)
        .then(() => {})
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    aceitar: function (index) {
      const self = this;
      let api =
        self.$store.state.api +
        "material_pedidos/" +
        self.pedido.materiais[index].id;

      self.pedido.materiais[index].atendido = 1;
      self.pedido.materiais[index]._method = "PUT";

      axios
        .post(api, self.pedido.materiais[index])
        .then(() => {
          self.verificaRecusa();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    recusar: function (index) {
      const self = this;
      let api =
        self.$store.state.api +
        "material_pedidos/" +
        self.pedido.materiais[index].id;

      self.pedido.materiais[index].atendido = 0;
      self.pedido.materiais[index]._method = "PUT";

      axios
        .post(api, self.pedido.materiais[index])
        .then(() => {
          self.verificaRecusa();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    cancelar: function (index) {
      const self = this;
      let api =
        self.$store.state.api +
        "material_pedidos/" +
        self.pedido.materiais[index].id;

      self.pedido.materiais[index].atendido = null;
      self.pedido.materiais[index]._method = "PUT";

      axios
        .post(api, self.pedido.materiais[index])
        .then(() => {
          self.verificaRecusa();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    verificaRecusa: function () {
      const self = this;

      let i = 0;

      self.pedido.materiais.forEach((material) => {
        if (material.atendido == 0) {
          self.recusado = true;
        } else {
          i++;
        }
      });

      if (self.pedido.materiais.length === i) {
        self.recusado = false;
      }
      console.log(self.recusado);
    },
    startDrawing(event) {
      this.isDrawing = true;
      const { offsetX, offsetY } = event;
      this.lastX = offsetX;
      this.lastY = offsetY;
    },
    draw(event) {
      if (!this.isDrawing) return;
      const { offsetX, offsetY } = event;

      const canvas = this.$refs.canvas;
      this.ctx = canvas.getContext("2d");
      this.ctx.beginPath();
      this.ctx.moveTo(this.lastX, this.lastY);
      this.ctx.lineTo(offsetX, offsetY);
      this.ctx.strokeStyle = "#000000";
      this.ctx.lineWidth = 1;
      this.ctx.stroke();
      this.lastX = offsetX;
      this.lastY = offsetY;
      this.drawingData.push({ x: offsetX, y: offsetY });
    },
    stopDrawing() {
      this.isDrawing = false;
      this.signature = document.getElementById("canvas");
    },
    clearSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.geolocalizacao = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
          },
          (error) => {
            this.error = "Erro ao obter geolocalização: " + error.message;
          }
        );
      } else {
        this.error = "Geolocalização não é suportada pelo navegador.";
      }
    },
    separar: function () {
      const self = this;

      // Validação dos campos obrigatórios
      if (!self.separador.nome || !self.separador.cpf) {
        self.$message(null, "Nome e CPF são obrigatórios", "error");
        return;
      }

      const api = self.$store.state.api + `public_separar/${self.pedido.id}`;

      const data = {
        nome: self.separador.nome,
        cpf: self.separador.cpf,
      };

      axios
        .post(api, data)
        .then((response) => {
          self.separado = false;
          self.$message(null, "Separação iniciada com sucesso", "success");
          self.getPedidos(self.pedido.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    aguardarTransporte: function () {
      const self = this;
      const api =
        self.$store.state.api + `public_aguardar_transporte/${self.pedido.id}`;

      axios
        .post(api)
        .then((response) => {
          self.separado = true;
          self.getPedidos(self.pedido.id);

          self.redirect();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    entregar: function (entregue) {
      const self = this;
      const api = self.$store.state.api + `public_entregue/${self.pedido.id}`;

      if (!self.entregador.nome && !self.entregador.cpf && entregue) {
        self.$message(
          null,
          "Por favor, preencha o nome e o CPF do entregador",
          "error"
        );
        return;
      }

      axios
        .post(api, {
          entregue: entregue,
          entregador: self.entregador,
          observacao: self.observacao,
        })
        .then((response) => {
          self.separado = true;
          self.getPedidos(self.pedido.id);

          self.redirect();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    redirect: function () {
      this.$router.push("/finalizado");
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getLocation();

    if (id) {
      self.getPedidos(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    MapComponent,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
.badge-orange {
  background: #d34300;
  color: white;
}
.badge-purple {
  background: #880088;
  color: white;
}
</style>